module.exports = __webpack_public_path__ + "static/how-we-decide-6517ff31d2adb80c5afa6f0d82287aa1.jpg";